export default __webpack_public_path__ + "static/media/KONE_Information_pdf.8f9b12d9.ttf";